module.exports = __webpack_public_path__ + "files/17ee64e0def7d0904bbfffc55533cc6f.png";